// export const BASE_URL = "http://localhost:8000";
// export const api_url = "http://localhost:8000";

// export const BASE_URL = "https://lcapi.rxultimate.com";
// export const api_url = "https://lcapi.rxultimate.com";

export const BASE_URL = "https://apiv1.lifechemistghana.com";
export const api_url = "https://apiv1.lifechemistghana.com";

export const endpoints = {
  login: "/authentication/login/",
};
